import { createAction } from 'redux-actions'

export const addErrorMessages = createAction('ERROR/ADD_ERROR_MESSAGES')

export const clearErrorMessages = createAction('ERROR/CLEAR_ERROR_MESSAGES')
